/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsaddanswer3Inputs */

const en_openquestionsaddanswer3 = /** @type {(inputs: Openquestionsaddanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add answer`)
};

const pt_openquestionsaddanswer3 = /** @type {(inputs: Openquestionsaddanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar resposta`)
};

/**
* | output |
* | --- |
* | "Add answer" |
*
* @param {Openquestionsaddanswer3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsaddanswer3 = /** @type {((inputs?: Openquestionsaddanswer3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsaddanswer3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsaddanswer3(inputs)
	return pt_openquestionsaddanswer3(inputs)
});
export { openquestionsaddanswer3 as "openQuestionsAddAnswer" }